import DaysOfWeek from './days-of-week';

export default DaysOfWeek;